import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import SelectComany from './ewCompanies'
import UserDetail from './userDetail'
import EwUsers from './ewUsers'
import { getUsers, clearRoles, uploadUsers, intializeUam } from '../action/userActions'
import { fetchEwCompanies, clearCos } from '../action/ewCompanyActions'
import { fetchEwGroups, clearGroups } from '../action/ewGroupActions'
import { connect } from 'react-redux'
import { Button, Container } from 'react-bootstrap'
import UploadUsers from './uploadModal'
import CreateImps from './createImpersonations'
import Slide from 'react-reveal/Slide';
import Spinner from '../../FTPMgt/component/Spinner'

class CompanyUsers extends Component {

    constructor(props) {
        super(props)
        this.state = { file: null }
    }

    componentDidMount() {
        this.props.dispatch(intializeUam())
    }

    render() {
        return (

            <div>
                <Spinner />
                <Slide left >

                    <table style={{ margin: 'auto' }}>
                        <tbody>
                            <tr>
                                <td>
                                    <SelectComany />

                                </td>
                                <td>

                                    <Button onClick={() => { this.props.history.push('/create') }}> Add User</Button>

                                </td>
                                <td>
                                    <UploadUsers />
                                </td>
                                <td>
                                    <CreateImps />
                                </td>
                            </tr>
                        </tbody>
                    </table>



                    < br />
                    <Container>
                        <EwUsers />

                    </Container>

                </Slide>


            </div>)
    }
}
const mapStateToProps = state => (
    {
        users: state.acct.user.users,
        groups: state.acct.ewGroup.groups,
        selectedUser: state.acct.user.selectedUser,
        cos: state.acct.ewCo.companies,
    });

export default withRouter(connect(mapStateToProps)(CompanyUsers))